import Header from '../components/header.js';
import WhiteThinLine from '../components/line.js';
import CheckIsMobile from '../components/mobile.js';

function About() {
    let isMobile = CheckIsMobile();

    let ParagraphStyle = {
        lineHeight: 1.8, 
        color: "white", 
        fontSize: isMobile ? "1.3rem" : "1.5rem", 
        paddingLeft: isMobile ? 50 : 75,
        paddingRight: isMobile ? 25 : 40, 
        font: "large", 
        alignItems: "center", 
        justifyContent: "center"
    }
    
    let ImageStyle = { 
        backgroundImage: `url('https://amvco.com.au/wp-content/uploads/2021/05/about-hero-1400x800-2880w.jpg')`, 
        width: "100%", 
        height: isMobile ? "70vh" : "100vh",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat"
    }
    
    return (
        <div style={{background: "black",}}>
            <Header />

            <section style={ ImageStyle } />
                
            <section style={ ParagraphStyle }>
                <p><br/>Australian Machine Vision is based in Seaford Victoria and has provided custom inspection, process control, and robot guidance solutions to Australian businesses since 2005.</p> <br/>
                <p>We have successfully applied "<b>area scan</b>", "<b>line scan</b>", "<b>laser triangulation</b>" and "<b>time-of-flight</b>" technologies in a broad range of food & beverage, pharmaceutical, packaging, and industrial applications.</p> <br/>
            </section>
            
            <WhiteThinLine />
            
            <br/> 
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center"}}> 
                <h1 style={{color:"cyan", fontSize: isMobile ? "1.5rem" : "2.5rem", textAlign: "center"}}> To find out more, call us today on 0418 535 729. </h1>
            </div>

            <br/> <hr style={{ borderWidth: "1.5px", borderColor: "white", width: "90%",          
                         marginLeft: "auto", marginRight: "auto", marginTop: "1rem" }} /> 
                         
            <br/> <br/> <br /> <br /> <br />
        </div>
    )
}

export default About;
